import React from 'react';
import PremiumSectionContainer from '../components/PremiumSectionContainer';
import PremiumSection from '../components/PremiumSection';
import { PickupSection } from '../sections/PickupSection';
import { DropoffSection } from '../sections/DropoffSection';
import { LoadSection } from '../sections/LoadSection';

export const TicketFormBaseInputsBlock = (props) => {
  const { ticketFormBodyData } = props;
  return (
    <PremiumSectionContainer>
      <PremiumSection>
        <PickupSection ticketFormBodyData={ticketFormBodyData} />
        <DropoffSection ticketFormBodyData={ticketFormBodyData} />
        <LoadSection ticketFormBodyData={ticketFormBodyData} />
      </PremiumSection>
    </PremiumSectionContainer>
  );
};
